"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UnauthAccess_1 = require("./UnauthAccess");
exports.default = UnauthAccess_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/UnauthAccess/index.js
// module id = 2372
// module chunks = 8